var taricCodelists = angular.module('taric.moreinfo.codelists', ['taric.moreinfo.codelists.search', 'taric.moreinfo.codelists.view']);
taricCodelists.config(function ($stateProvider) {
    $stateProvider.state('taric.moreinfo.codelists', {
            abstract: true,
            url: '/codelists',
            template: '<ui-view></ui-view>'
        }).state('taric.moreinfo.codelists.search', {
            url: '/search?sd&ct&l&ql&frm',
            templateUrl: 'taric/moreinfo/codelists/search/codelists-search.tmpl.html',
            controller : 'SearchCodelistsController as searchCodelistsCtrl',
            reloadOnSearch: false,
            resolve: {
                initializeData: function(CodeListsModel, $stateParams, $translate, CommonHelper){
                    if ($stateParams.frm !== 'taric.moreinfo.codelists.view') {
                        CodeListsModel.reset();
                    }
                    if ($stateParams.sd){
                        var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                        if (inputDate) {
                            CodeListsModel.getSearchCriteria().simulationDate = inputDate;
                        }
                    }
                    if ($stateParams.ct) {
                        CodeListsModel.getSearchCriteria().codeType = $stateParams.ct;
                    }
                    if ($stateParams.l){
                        $translate.use($stateParams.l);
                        CodeListsModel.getSearchCriteria().language = $stateParams.l;
                    }
                    if ($stateParams.ql){
                        CodeListsModel.getSearchCriteria().language = $stateParams.ql;
                    }
                },
                preferredUILanguages: function (LanguageModel) {
                    return LanguageModel.getPreferredUILanguages();
                },
                loadTranslation: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('taric/moreinfo/codelists');
                },
                setupMenu: function (MenuModel) {
                	
                	MenuModel.setHelpIndex(this.name);
                	MenuModel.notifyObservers();
                }
            }
        }).state('taric.moreinfo.codelists.view', {
            url: '/view',
            templateUrl: 'taric/moreinfo/codelists/view/codelists-view.tmpl.html',
            controller : 'ViewCodelistsController as viewCodelistsCtrl',
            resolve: {
                codeTypeChildren : function (CodeListsModel){
                    return CodeListsModel.getSelectedRow();
                },
                simulationDate : function (CodeListsModel){
                    return CodeListsModel.getSearchCriteria().simulationDate;
                },
                showCancelButton: function (){
                    return true;
                },
                $uibModalInstance : function(){
                    return null;
                },
                codeType: function (CodeListsModel){
                    return CodeListsModel.getSearchCriteria().codeType;
                },
                setupMenu: function (MenuModel) {
                	
                	MenuModel.setHelpIndex(this.name);
                	MenuModel.notifyObservers();
                }
            }
        });

});



// WEBPACK FOOTER //
// ./app/taric/moreinfo/codelists/taric-codelists.js